
import PageBlocks from '@/components/PageBlocks.vue';
import { CompanyCardsGrid } from '@/domains/company';
import {
  useFetch,
  defineComponent,
  watch,
  computed,
} from '@nuxtjs/composition-api';
import { useAsbisCompanies, usePaginationData } from '~/composables';
import { useFetchPage } from '@webplatform/nuxt-cms-js-sdk';
import { prepareBreadcrumbs } from '~/helpers';

export default defineComponent({
  components: {
    PageBlocks,
    CompanyCardsGrid,
  },
  setup() {
    const { page, fetchPage } = useFetchPage('asbis-in-your-country');

    const { companies, meta, fetchCompanies } = useAsbisCompanies();

    const { currentPage } = usePaginationData(meta);

    useFetch(async () => {
      try {
        await fetchPage();
        await fetchCompanies();
      } catch (e) {
        console.error(e);
      }
    });

    watch(currentPage, () => {
      fetchCompanies();
    });

    const sortedCompanies = computed({
      get() {
        if (companies && companies.value.length) {
          return [...companies.value].sort((c1, c2) => {
            return c1?.country?.localeCompare(c2?.country);
          });
        }

        return [];
      },
      set() {},
    });

    const breadcrumbs = computed(() => [
      ...(page.value?.breadcrumbs || []).map(prepareBreadcrumbs),
      {
        text: page.value?.title,
      },
    ]);

    return {
      page,
      meta,
      breadcrumbs,
      companies,
      sortedCompanies,
    };
  },
  head: {},
});
